<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XDUDXK/tc-custom/9780804798617.jpg?1705766093170" alt="This image is the cover for the book Use of Bodies, Meridian: Crossing Aesthetics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Use of Bodies, Meridian: Crossing Aesthetics
      </h1>
      <p class="bookDescription body article font2">
        <b>The renowned philosopher and author of <i>Homo Sacer</i> continues his groundbreaking work with this examination of selfhood and Western ontology.</b><br/><br/>Giorgio Agamben’s <i>Homo Sacer</i> was one of the most influential works of political philosophy in recent decades. It was also the beginning of a series of studies investigating the deepest foundations of Western politics and thought. <i>The Use of Bodies</i> represents the ninth and final volume in this twenty-year undertaking, breaking considerable new ground while clarifying the stakes and implications of the project as a whole. <br/><br/><i>The Use of Bodies</i> comprises three major sections. The first uses Aristotle’s discussion of slavery as a starting point for radically rethinking notions of selfhood; the second calls for a complete reworking of Western ontology; and the third explores the enigmatic concept of “form-of-life,” which is in many ways the motivating force behind the entire <i>Homo Sacer</i> project. <br/><br/>Interwoven between these major sections are shorter reflections on individual thinkers (Debord, Foucault, and Heidegger), while the epilogue pushes toward a new approach to political life that breaks with the destructive deadlocks of Western thought. <i>The Use of Bodies</i> represents a true masterwork by one of our greatest living philosophers.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Giorgio Agamben, Adam Kotsko
      </h2>
      
      <p class="authorDescription body article"><B>Giorgio Agamben</B> is a contemporary Italian philosopher and political theorist whose works have been translated into numerous languages. His most recent title with Stanford University Press is <I>Stasis</I> (2015).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Stanford University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?258b287e